import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=6d075cb7&"
import script from "./side-menu-item.vue?vue&type=script&lang=js&"
export * from "./side-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports